import React, { useEffect, useState } from "react";
import BodyMain from "../../components/util/BodyMain";
import { Badge, TextField, Select, Button, Box, IconButton, Typography, Divider, Grid, FormControl, InputLabel, FormHelperText } from "@mui/material";

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { constants } from '../../util'
import { deleteAlbum, evalAlbum, getAlbumListApproval, publishAlbum } from "../../services/albumService";

import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import ChatIcon from '@mui/icons-material/Chat';
import MenuIcon from '@mui/icons-material/Menu';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import PreviewIcon from '@mui/icons-material/Preview';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ReplyIcon from '@mui/icons-material/Reply';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import HomeIcon from '@mui/icons-material/Home';
import Confirmation from "../../components/message/confirmation";
import { showWaiting } from "../../store/slices/configSlice";
import { enqueueSnackbar } from 'notistack';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import AudioPlayer from "../../components/util/audioPlayer";
import { fileUpload } from "../../helpers/fileUpload";
import Chat from "./chat";
import CommentDialog from "../../components/message/commentDialog";


const ApprovalSongs = () => {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");
    const {language} = useSelector(state => state.configuration);

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [filters, setFilters] = useState({
        startDate: dayjs().subtract(1, 'month').toISOString(),
        endDate: dayjs().add(1, 'month').toISOString(),
        statusId: 905,
        album: '',
        song: '',
        artist: '',
    });
    const [currentAlbumId, setCurrentAlbumId] = useState(null);
    const [currentAlbumName, setCurrentAlbumName] = useState(null);
    const [currentAlbumDisabled, setCurrentAlbumDisabled] = useState(false);
    const [currentItemIsEvalued, setCurrentItemIsEvalued] = useState(false);
    
    const [currentItemAsAlbum, setCurrentItemAsAlbum] = useState(null);
    const [currentItemPublished, setCurrentItemPublished] = useState(false);
    
    const [result, setResult] = useState(undefined);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showConfirmPublish, setShowConfirmPublish] = useState(false);
    const [selectedItemDelete, setSelectedItemDelete] = useState(-1);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationAction, setConfirmationAction] = useState('');
    const [confirmationTitle, setConfirmationTitle] = useState('');
    const [confirmationContent, setConfirmationContent] = useState('');

    const [confirmationTitleComments, setConfirmationTitleComments] = useState('');
    const [confirmationContentComments, setConfirmationContentComments] = useState('');
    const [showConfirmationComments, setShowConfirmationComments] = useState(false);
    const [selectedAction, setSelectedAction] = useState(null);

    const [showMessagesPopup, setShowMessagesPopup] = useState(false);

    const {deviceType} = useSelector(state => state.configuration);
    const navigate = useNavigate();
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);


    const sch = (yup) => yup.object({
        startDate: yup.string().required(),
        endDate: yup.string().required(),
        statusId: yup.string().max(40),
        album: yup.string().max(40),
        song: yup.string().max(40),
        artist: yup.string().max(40),
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                startDate: dayjs().subtract(1, 'month').toISOString(),
                endDate: dayjs().add(1, 'month').toISOString(),
                statusId: 905,
                album: '',
                song: '',
                artist: '',
            }
        });


    const columns = [
        {
            field: 'albumId',
            description: '',
            headerName: '',
            type: 'string',
            width: 60,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            display:'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClickMenu(e, params.row.albumId, params.row.isAlbum, params.row.status)} // Función para editar
                                aria-label="Editar"
                                // sx={{alignSelf:'center', placeSelf:'center'}}
                            >
                                <MenuIcon fontSize="large" />
                            </IconButton>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'albumPhoto',
            description: t("songs.gridColumn1"),
            headerName: t("songs.gridColumn1"),
            type: 'string',
            width: 140,
            headerAlign: 'left',
            renderCell: (params) => {
                // Si la URL está vacía, puedes mostrar un placeholder o nada
                if (!params.value) return null;
                
                return (
                    <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                        <img 
                            src={params.value}
                            alt="Album cover" 
                            style={{ 
                                width: '100px', 
                                height: '100px',
                                objectFit: 'cover',
                                borderRadius: '4px'
                            }} 
                        />
                    </div>
                );
            }
        },
        {
            field: 'b',
            description: t("songs.gridColumn2"),
            headerName: t("songs.gridColumn2"),
            type: 'string',
            width: 180,
            headerAlign: 'left',
            renderCell: (params) => (
                <div style={{ width: '100%', height:'100%', 
                        display:'flex',
                        justifyContent:'flex-start', 
                    }}
                >
                    <div style={{alignSelf:'center'}}>
                        <strong style={{ color: '#667', fontSize: '0.8rem' }}>{params.row.title}</strong>
                        {/* <div style={{ color: '#666', fontSize: '0.8rem' }}>{params.row.mainArtist}</div> */}
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.launchingDate.substring(0,10)}</div>
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.isAlbum ? 
                                                                    (language==='es' ? `Álbum (${params.row.numSongs})` : `Album (${params.row.numSongs})`) : (language==='es' ? 'Canción' : 'Single song')}</div>
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.foundArtist}</div>
                        <div style={{
                            backgroundColor: params.row.colorStatus==='yellow' ? '#FFFB95' : ( params.row.colorStatus==='green' ? '#95FFA6' : ( params.row.colorStatus==='blue' ? '#DDE6FF' : '#FFC7C7')),
                            border: params.row.colorStatus==='yellow' ? '1px solid #CBA600' : ( params.row.colorStatus==='green' ? '1px solid #009C17' : ( params.row.colorStatus==='blue' ? '1px solid #0136BD' : '1px solid #C00000')),
                            width:'80px',
                            height:'25px',
                            textAlign:'center',
                            alignContent:'center',
                            borderRadius:'7px',
                            color: '#667', 
                            fontSize: '0.7rem',
                            fontWeight: 'bold',
                        }}>
                            {
                                language==='es' && params.row.status==='Pending' 
                                    ? "Pendiente"
                                    : language==='es' && params.row.status==='Approved' 
                                        ? "Aprobado"
                                        : language==='es' && params.row.status==='Rejected' 
                                            ? "Rechazado"
                                            : language==='es' && params.row.status==='Published' 
                                                ? "Publicado"
                                                : language==='en' && params.row.status==="Pendiente" 
                                                    ? "Pending"
                                                    : language==='en' && params.row.status==='Aprobado' 
                                                        ? "Approved"
                                                        : language==='en' && params.row.status==='Rechazado' 
                                                            ? "Rejected"
                                                            : language==='en' && params.row.status==='Publicado' 
                                                                ? "Published"
                                                                : params.row.status
                            }
                        </div>
                    </div>
                </div>
            ),
        },
        {
            field: 'ba',
            description: t("songs.gridColumn5"),
            headerName: t("songs.gridColumn5"),
            type: 'string',
            width: 150,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%',  height:'100%', display:'flex', justifyContent:'center', alignContent:'center'}}>
                        <div style={{alignSelf:'center', textAlign:'center'}}>
                            <IconButton 
                                color="primary"
                                onClick={() => handleViewMessages(params.row.albumId, params.row.title, params.row.colorStatus==='red')} // Función para editar
                                aria-label="Editar"
                            >
                                <Badge badgeContent={params.row.numSongsNotSeen} color="error">
                                    <ChatIcon fontSize="large" />
                                </Badge>
                            </IconButton>
                            <div style={{width:'100%', textAlign:'center', color: '#667', fontSize: '0.8rem'}}>{t("songs.gridOption1")}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'audioFile',
            description: t("songs.gridColumn6"),
            headerName: t("songs.gridColumn6"),
            type: 'string',
            width: 400,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%',  height:'100%', display:'flex', direction:'column', justifyContent:'center', alignContent:'center'}}>
                        
                        {
                            params.value === '' || params.value === undefined
                                ? 
                                    <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center'}}>
                                        <Button
                                            component="label"
                                            variant="text"
                                            sx={{ ...constants.styles.linkButton, color:'blue', textTransform:'none' }}
                                            onClick=
                                                {(e) =>{ 
                                                    // setCurrentAlbumId(); 
                                                    handleClickMenu_Go('view', params.row.albumId)
                                                }}
                                        >
                                            Ver canciones del álbum
                                        </Button>
                                    </div>
                                : 
                                    <div style={{height:'100%', alignContent:'center'}}>
                                        <AudioPlayer audioUrl={params.value} filenameToDownload='' />
                                        <div style={{ color: '#667', fontSize: '0.7rem' }}>
                                            {params.row.foundSong}
                                        </div>
                                    </div>
                        }
                    </div>
                );
            }
        },
    ];


    const handleViewMessages = (albumId, albumName, disable) => {
        setCurrentAlbumId(albumId);
        setCurrentAlbumName(albumName);
        setCurrentAlbumDisabled(disable);
        setShowMessagesPopup(true);
        
        setRows(
            rows.map( obj => obj.albumId === albumId ? { ...obj, numSongsNotSeen:0} : obj)
        );
    }

    const onSubmit = (data) => {
        dispatch(showWaiting(true));
        getAlbumListApproval(
            data.startDate, 
            data.endDate, 
            data.statusId, 
            data.album, 
            data.song, 
            data.artist
        )
        .then((rsp) => {
            setTimeout(() => {
                if (rsp.code === '00'){
                    setRows(rsp.metadata);
                    dispatch(showWaiting(false));
                    
                    if (rsp.metadata?.length > 0)
                        enqueueSnackbar(
                            language === 'es'
                                ? 'Álbumes y canciones cargadas con éxito'
                                : 'Albums and songs was loaded successfully'
                            , { variant: 'success', persist: false }
                        );
                    else
                        enqueueSnackbar(
                            language === 'es'
                                ? 'No hay coincidencias'
                                : 'No matches found'
                            , { variant: 'error', persist: false }
                        );
                }
                else{
                    setRows([])
                    dispatch(showWaiting(false));
                    enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                }
            }, 1000);
        });

        setFilters(
            {
                ...filters,
                startDate: data.startDate, 
                endDate: data.endDate, 
                statusId: data.statusId, 
                album: data.album, 
                song: data.song, 
                artist: data.artist
            }
        )
    }


    const handleDelete = (responseDelete) => {
            if (responseDelete){
                dispatch(showWaiting(true));
    
                deleteAlbum(
                    currentAlbumId,
                ).then(
                    (rsp) => {
                        setTimeout(() => {
                            getAlbumList(null)
                                .then((rsp) => {
                                    setRows(rsp.metadata)
                                });
                    
                            enqueueSnackbar(rsp.message, 
                                { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                            dispatch(showWaiting(false));
                        }, 1000);
                    }
                );
            }
        }
    
    
    const handlePublish = (responsePublish) => {
            if (responsePublish){
                dispatch(showWaiting(true));
    
                publishAlbum(
                    currentAlbumId,
                ).then(
                    (rsp) => {
                        setTimeout(() => {
                            getAlbumList(null)
                                .then((rsp) => {
                                    setRows(rsp.metadata)
                                });
                    
                            enqueueSnackbar(rsp.message, 
                                { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                            dispatch(showWaiting(false));
                        }, 1000);
                    }
                )
                .catch(err => {
                    enqueueSnackbar("error", 
                        { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                    dispatch(showWaiting(false));
                });
            }
        }


    const handleClickMenu = (event, id, isAlbum, status) => {
        setAnchorEl(event.currentTarget);
        setCurrentAlbumId(id);
        setCurrentItemAsAlbum(isAlbum);
        setCurrentItemPublished(status==='Published' || status==='Publicado');
        setCurrentItemIsEvalued(
            status==='Aprobado' 
            || status==='Rechazado'
            || status==='Approved' 
            || status==='Rejected'
        )
    };

    
    const handleClickMenu_Go = (action, currentId) => {
        setSelectedAction(action);
console.log(currentId);

        switch(action){
            case "view":
                navigate('/addalbum', 
                    {
                        state: {
                            action: action,
                            selectedAlbumId: (currentAlbumId || currentId) || -1,
                            isAlbum: currentItemAsAlbum
                        }
                    }
                );
                break;
            default:
                setConfirmationAction(action);
                setConfirmationTitle(language === 'es' ? 'Confirmación' : 'Confirmation');

                const accionEspanol = 
                setConfirmationContent(
                    language === 'es'
                        ? `¿Está seguro que desea ${
                                action==='approve'
                                    ? "aprobar"
                                    : action==='return'
                                        ? "regresar"
                                        : action==='reject'
                                            ? "rechazar"
                                            : ''
                        } el elemento seleccionado?`
                        : `Are you sure that you wish to ${action} the selected item?`
                );
                setShowConfirmation(true);
                break;
        }
    }


    const handleResponse = (response) => {
        if (response){
            if (selectedAction==='reject'){
                setConfirmationTitleComments(t("approvalSongs.reasonTitle"));
                setConfirmationContentComments(t("approvalSongs.reasonContent"));
                setShowConfirmationComments(true);
            }
            else{
                setEvaluation('');
            }
        }
    }


    const handleResponseComments = (response, comments) => {
        if (response) {
            setEvaluation(comments);
        }
    }


    const setEvaluation = ( comments ) => {
        dispatch(showWaiting(true));

        evalAlbum(
            currentAlbumId,
            confirmationAction,
            comments
        ).then(
            (rsp) => {
                setTimeout(() => {
                    const {startDate, endDate, statusId, album, song, artist} = filters;

                    getAlbumListApproval(startDate, endDate, statusId, album, song, artist)
                        .then((rsp) => {
                            setRows(rsp.metadata)
                        });
            
                    enqueueSnackbar(rsp.message, 
                        { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                    dispatch(showWaiting(false));
                }, 1000);
            }
        )
        .catch(err => {
            enqueueSnackbar("error", 
                { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
            dispatch(showWaiting(false));
        });
    }


    const handleCloseMenu = () => {
        setAnchorEl(null);
    };


    const handleClick_Question = (answer) => {
        setOpen(false);
        switch(answer)
        {
            case "singleSong":
                navigate("/addsinglesong");
                break;
            case "album":
                navigate("/addalbum");
                break;
            default:
                break;
        }
    }

    useEffect(()=>{
        const {startDate, endDate, statusId, album, song, artist} = filters;

        getAlbumListApproval(startDate, endDate, statusId, album, song, artist)
            .then((rsp) => {
                setRows(rsp.metadata)
            })
    }, [])


    return(
        <>
            <BodyMain>
                <h2 style={{color:'#667'}}>{t("approvalSongs.title")}</h2>
                <form onSubmit={handleSubmit(onSubmit)}
                    style={{
                        width:'100%',
                        height:'100%',
                        display:'flex',
                        flexDirection:'column',
                        marginBottom:'50px'
                    }}
                >
                    <Grid container spacing={2} direction="row">
                        <Grid size={6} direction="column">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']} sx={{marginBottom:'8px'}}>
                                    <Controller
                                        name="startDate"
                                        control={control}
                                        render={({ field, fieldState: { error } }) => (
                                            <DatePicker
                                                label={t("approvalSongs.filterStartDate")}
                                                format="DD/MM/YYYY"
                                                value={field.value ? dayjs(field.value) : null}
                                                onChange={(date) => {
                                                    if (date) {
                                                        // Cuando el usuario selecciona una fecha, la convertimos a string ISO
                                                        const isoDateString = dayjs(date).format('YYYY-MM-DD');
                                                        field.onChange(isoDateString||'T00:00:00');
                                                    } else {
                                                        // Si limpia la fecha, guardamos null o string vacío
                                                        field.onChange(null);
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: !!error,
                                                        helperText: error?.message,
                                                    },
                                                }}
                                                sx={{ marginBottom: '15px' }}
                                            />
                                        )}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']} sx={{marginBottom:'15px'}}>
                                    <Controller
                                        name="endDate"
                                        control={control}
                                        render={({ field, fieldState: { error } }) => (
                                            <DatePicker
                                            label={t("approvalSongs.filterEndDate")}
                                            format="DD/MM/YYYY"
                                            value={field.value ? dayjs(field.value) : null}
                                            onChange={(date) => {
                                                if (date) {
                                                    // Cuando el usuario selecciona una fecha, la convertimos a string ISO
                                                    const isoDateString = dayjs(date).format('YYYY-MM-DD');
                                                    field.onChange(isoDateString||'T00:00:00');
                                                } else {
                                                    // Si limpia la fecha, guardamos null o string vacío
                                                    field.onChange(null);
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                error: !!error,
                                                helperText: error?.message,
                                                },
                                            }}
                                            sx={{ marginBottom: '15px' }}
                                            />
                                        )}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>

                            <Controller
                                name="statusId"
                                control={control}
                                render={({ field }) => (
                                <FormControl fullWidth error={!!errors.statusId}>
                                    <InputLabel id="status-label">{t("approvalSongs.filterStatus")}</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="status-label"
                                        label={t("approvalSongs.filterStatus")}
                                        sx={{ width: '100%', marginBottom: '0px' }}
                                    >
                                        <MenuItem value={-1}>
                                            <Typography>{ language==='es' ? 'Todos los estatus' : 'All status'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={905}>
                                            <Typography>{ language==='es' ? 'Publicado' : 'Published'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={910}>
                                            <Typography>{ language==='es' ? 'Aprobado' : 'Approved'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={930}>
                                            <Typography>{ language==='es' ? 'Rechazado' : 'Rejected'}</Typography>
                                        </MenuItem>
                                    </Select>
                                    {/* <FormHelperText>
                                        {errors.statusId?.message}
                                    </FormHelperText> */}
                                </FormControl>
                                )}
                            />
                        </Grid>

                        <Grid size={6} direction="column" spacing={2} sx={{paddingTop:'8px'}}>
                            <TextField id="txtAlbum" label={t("approvalSongs.filterAlbum")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('album')}
                                error={!!errors.album}
                                helperText={errors.album?.message}
                            />

                            <TextField id="txtSong" label={t("approvalSongs.filterSong")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('song')}
                                error={!!errors.song}
                                helperText={errors.song?.message}
                            />

                            <TextField id="txtArtist" label={t("approvalSongs.filterArtist")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('artist')}
                                error={!!errors.artist}
                                helperText={errors.artist?.message}
                            />
                        </Grid>
                        <Button
                            type="submit"
                            variant="outlined"
                            sx={{ ...constants.styles.mainButton, width: 'auto-fit', paddingLeft:'80px', paddingRight:'80px' }}
                        >
                            {t("approvalSongs.btnSearch")}
                        </Button>
                    </Grid>
                </form>
                <Box sx={{ 
                    width: '100%',
                    '& .alternateClass': {
                        backgroundColor: '#f2f2f2',
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .rowClass': {
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .alternateClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                    '& .rowClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                }}>
                    
                    {/* <div style={{ display: 'flex', flexDirection: 'column' }}> */}
                        <DataGrid
                            getRowId={(row) => row.albumId}
                            getRowHeight={() => 'auto'}
                            rows={rows}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10,
                                    },
                                },
                                density: 'compact',
                            }}
                            getRowClassName ={
                                (params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                            }
                            pageSizeOptions={[5,10,20,{value:-1, label:language==='es' ? 'Todo' : 'All'}]}
                            checkboxSelection = {false}
                            disableRowSelectionOnClick
                            disableColumnMenu={false}
                            slots={{
                                toolbar: GridToolbar,
                            }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                }
                            }}
                            localeText={
                                language === 'es' 
                                ? esES.components.MuiDataGrid.defaultProps.localeText
                                : enUS.components.MuiDataGrid.defaultProps.localeText
                            }
                            sx={{
                                '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                    color: '#667', 
                                    fontSize: '0.8rem',
                                },
                            }}
                        />
                    {/* </div> */}
                </Box>
            </BodyMain>

            <Menu 
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 120,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => handleClickMenu_Go('view')}>
                    <VisibilityIcon sx={{marginRight:'15px'}} />
                    {t("approvalSongs.gridMenu_view")}
                </MenuItem>
                <Divider />
                <MenuItem disabled={currentItemIsEvalued} onClick={()=> handleClickMenu_Go('approve')}>
                    <CheckCircleIcon sx={{marginRight:'15px', color:'green'}} />
                    {t("approvalSongs.gridMenu_approve")}
                </MenuItem>
                <Divider />
                <MenuItem disabled={currentItemIsEvalued} onClick={()=> handleClickMenu_Go('return')}>
                    <SwapHorizontalCircleIcon sx={{marginRight:'15px', color:'coral'}} />
                    {t("approvalSongs.gridMenu_return")}
                </MenuItem>
                <MenuItem disabled={currentItemIsEvalued} onClick={()=> handleClickMenu_Go('reject')}>
                    <CancelIcon sx={{marginRight:'15px', color:'red'}} />
                    {t("approvalSongs.gridMenu_reject")}
                </MenuItem>
            </Menu>


            <Confirmation title={confirmationTitle} content={confirmationContent}
                open={showConfirmation} onClose={()=>setShowConfirmation(false)} 
                onResponse={handleResponse} />
            
            <CommentDialog title={confirmationTitleComments} content={confirmationContentComments}
                open={showConfirmationComments} onClose={()=>setShowConfirmationComments(false)} 
                onResponse={handleResponseComments} />
            

            <Chat open={showMessagesPopup} albumId={currentAlbumId} albumName={currentAlbumName} disableChat={currentAlbumDisabled} onClose={()=>setShowMessagesPopup(false)} />
        </>
    );
}

export default ApprovalSongs;